import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5679fb1a"
import script from "./addMasterRule.js?vue&type=script&lang=js&external"
export * from "./addMasterRule.js?vue&type=script&lang=js&external"
import style0 from "./addMasterRule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports